import React, { useEffect, useState } from "react";
import { Modal } from "@opendate-app/setlist";

const SetupModal = ({
  venueOwnership,
  sendDomains,
}) => {
  const [showSetup, setShowSetup] = useState(false);

  useEffect(() => {
    if (!!venueOwnership) {
      setShowSetup(sendDomains.length === 0)
    }
  }, [venueOwnership]);

  return (
    <Modal
      open={showSetup}
      onClose={() => setShowSetup(false)}
      title="Let's get set up!"
      description="Before you can send emails we need to configure your account. Head on over to settings and set up your sending domain."
      confirmLabel="Set up sending domain"
      onConfirm={() => { window.location.href = `marketing_settings?venue_ownership_id=${venueOwnership.id}&tab=email`; }}
    />
  );
};

export default SetupModal;
